<template>
  <v-chip small :color="color" :text-color="textColor" label>
    {{ label }}
  </v-chip>
</template>

<script>
const STATUS_MAP = {
  pending: { label: 'Pendiente', color: 'orange lighten-4', textColor: 'orange darken-4' },
  active: { label: 'Activo', color: 'green lighten-4', textColor: 'green darken-4' },
  suspended: { label: 'Suspendido', color: 'red lighten-4', textColor: 'red darken-4' },
  provisioning_failed: { label: 'Error provisioning', color: 'grey lighten-2', textColor: 'grey darken-3' },
};

export default {
  name: 'BusinessStatusChip',
  props: {
    status: {
      type: String,
      required: true,
    },
  },
  computed: {
    config() {
      return STATUS_MAP[this.status] || { label: this.status, color: 'grey lighten-3', textColor: 'grey darken-2' };
    },
    label() {
      return this.config.label;
    },
    color() {
      return this.config.color;
    },
    textColor() {
      return this.config.textColor;
    },
  },
};
</script>
